import { render, staticRenderFns } from "./ViewCompletedDocument.vue?vue&type=template&id=6d41f20a&scoped=true"
import script from "./ViewCompletedDocument.vue?vue&type=script&lang=js"
export * from "./ViewCompletedDocument.vue?vue&type=script&lang=js"
import style0 from "./ViewCompletedDocument.vue?vue&type=style&index=0&id=6d41f20a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d41f20a",
  null
  
)

export default component.exports